import { categories, categoryBackgroundImages } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-4">
            Browse Products
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Popular Kakobuy Spreadsheet Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Explore our curated kakobuy spreadsheet categories and discover the best products across fashion, accessories, and more.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group card hover:border-primary-200/60 cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-48 overflow-hidden bg-background-100">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                  style={{
                    backgroundImage: `url(${categoryBackgroundImages[cat.seq] || ""})`,
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-3 md:p-4 flex items-center gap-2.5">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap truncate">
                  {cat.name}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 ml-auto flex-shrink-0"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}